export default __webpack_public_path__ + "static/media/manulife-logo.7e967806.png";